<template>
    <v-container>
        <v-container>
            <v-row>
                <!-- Card 1 -->
                <v-col cols="12" sm="6">
                    <v-card class="mx-auto text-center" max-width="344">
                        <img src="../assets/images/momah.png" class="mt-8"
                             alt="Eskan"
                             height="200" />
                        <v-card-title class="ma-auto d-block text-center"> {{ $t('Eskan') }}</v-card-title>
                        <v-card-subtitle></v-card-subtitle>
                        <v-card-text>

                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" to="/executive-analytics">{{$t('ReadMore')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>

                <!-- Card 2 -->
                <v-col cols="12" sm="6">
                    <v-card class="mx-auto text-center" max-width="344">
                        <img src="../assets/images/momah.png" class="mt-8"
                             alt="Balady"
                             height="200" />
                        <v-card-title class="ma-auto d-block text-center">  {{ $t('Balady') }}</v-card-title>
                        <v-card-subtitle></v-card-subtitle>
                        <v-card-text>

                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" to="/balady-analytics">{{$t('ReadMore')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>


                <!-- Card 3 -->
                <!--<v-col cols="12" sm="6" md="4">
                    <v-card class="mx-auto text-center" max-width="344">
                        <img src="../assets/images/momah.png" class="mt-8"
                             alt="Balady"
                             height="200" />
                        <v-card-title class="ma-auto d-block text-center">   {{ $t('Insights') }}</v-card-title>
                        <v-card-subtitle></v-card-subtitle>
                        <v-card-text>

                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" to="/insights">{{$t('ReadMore')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>-->

            </v-row>
        </v-container>
    </v-container>
</template>

<script>

    export default {
        components: {
        },
        directives: {
        },
        filters: {
        },
        props: {
        },
        data() {
            return {
            }
        },
        computed: {
        },
        watch: {
        },
        beforeCreate() {
        },
        created() {
        },
        beforeMount() {
        },
        mounted() {
        },
        updated() {
        },
        activated() {
        },
        deactivated() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        methods: {
        },
    }
</script>

<style>
</style>